import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Stack,
  CircularProgress,
  Box,
  Alert,
} from '@mui/material';

interface CheckoutRequestDialogProps {
  open: boolean;
  methods: string[];
  loadingMethods: boolean;
  submitting: boolean;
  error: string | null;
  onSelect: (paymentMethod: string) => void;
  onClose: () => void;
  /** すでに REQUESTED 中の再リクエスト（支払方法の変更・再通知）なら true。説明文に一言添える。ADR 0068 */
  isReRequest?: boolean;
}

// 会計リクエスト時に、店舗が設定した支払方法から顧客が希望を選ぶダイアログ。
const CheckoutRequestDialog: React.FC<CheckoutRequestDialogProps> = ({
  open,
  methods,
  loadingMethods,
  submitting,
  error,
  onSelect,
  onClose,
  isReRequest = false,
}) => {
  return (
    <Dialog
      open={open}
      onClose={submitting ? undefined : onClose}
      aria-labelledby="checkout-request-dialog"
      PaperProps={{ sx: { minWidth: '360px' } }}
    >
      <DialogTitle id="checkout-request-dialog">お会計</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          お支払い方法を選ぶと、店員にお会計をお知らせします。
          {isReRequest && (
            <>
              <br />
              選び直すと店員に再度お知らせします。
            </>
          )}
        </DialogContentText>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        {loadingMethods ? (
          <Box display="flex" justifyContent="center" py={3}>
            <CircularProgress size={28} />
          </Box>
        ) : (
          <Stack spacing={1.5}>
            {methods.map((method) => (
              <Button
                key={method}
                onClick={() => onSelect(method)}
                variant="contained"
                color="primary"
                size="large"
                disabled={submitting}
                fullWidth
              >
                {method}
              </Button>
            ))}
          </Stack>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} color="inherit" disabled={submitting} fullWidth>
          キャンセル
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CheckoutRequestDialog;
